import { useContext } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { StatusLabel } from '@shared/components/StatusLabel';
import { useDocumentTitle } from '@shared/hooks/useDocumentTitle.hook';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import SignInContext from '@modules/users/contexts/SignInContext.context';
import { useFolder } from '@modules/items/api/folders.api';
import { isTFolder } from '@modules/items/types/folders.types';
import { useChangeTemplate } from '../api';
import ChangeTemplateContent from '../components/ChangeTemplateContent';
import { isChangeTemplatesEnabled } from '../helpers';

const ChangeTemplate = () => {
  const { id } = useParams<{ id: string }>();
  const { organization } = useContext(SignInContext);
  const enabled = isChangeTemplatesEnabled(organization);
  const { data: qmData, error: qmError } = useFolder(organization.folders.qm, { enabled });
  const { data: rootData, error: rootError } = useFolder(organization.folders.changeTemplates, { enabled });
  const qmFolder = qmData && isTFolder(qmData) ? qmData : undefined;
  const rootFolder = rootData && isTFolder(rootData) ? rootData : undefined;
  const { data: details, error } = useChangeTemplate(id!, enabled);
  useDocumentTitle(details?.changeTemplate.title ?? TERMINOLOGY.changeTemplate.upper);

  if (!enabled) return <Navigate to="/" replace />;

  return (
    <StatusLabel
      data={qmFolder && rootFolder && details ? { qmFolder, rootFolder, details } : undefined}
      error={error ?? qmError ?? rootError}
      loadingMessage={`Loading ${TERMINOLOGY.changeTemplate.lower}...`}
      errorMessage={`Loading the ${TERMINOLOGY.changeTemplate.lower} failed!`}
      render={(resolved) => <ChangeTemplateContent {...resolved} />}
    />
  );
};

export default ChangeTemplate;
